import { Typography } from "@mui/material";
import { StyledSiniestralidad } from "../../../../../../styled/Siniestros";

const DinerariasHelperLabel = () => {

  return (
    <>
      <StyledSiniestralidad.GridItem item xs={4}>
        <StyledSiniestralidad.IconoStyle variant="h6">
          ILT
        </StyledSiniestralidad.IconoStyle>
        <Typography style={{ color: "grey" }}>
          Incapacidad Laboral Temporal
        </Typography>
      </StyledSiniestralidad.GridItem>

      <StyledSiniestralidad.GridItem item xs={4}>
        <StyledSiniestralidad.IconoStyle variant="h6">
          ILP
        </StyledSiniestralidad.IconoStyle>
        <Typography style={{ color: "grey" }}>
          Incapacidad Laboral Permanente
        </Typography>
      </StyledSiniestralidad.GridItem>

      <StyledSiniestralidad.GridItem item xs={4}>
        <StyledSiniestralidad.IconoStyle variant="h6">
          CGI
        </StyledSiniestralidad.IconoStyle>
        <Typography style={{ color: "grey" }}>
          Compensación por Gran Invalidez
        </Typography>
      </StyledSiniestralidad.GridItem>
    </>
  );
};

export default DinerariasHelperLabel;
